import DefaultLayout from './DefaultLayout';

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/components/DefaultLayout/index.js